<app-navbar-style-three></app-navbar-style-three>



<div class="container">
  <div class="row">
    <div class="col-lg-12">

     
      
      <section class="" style="padding: 20px 0px 40px 0px; font-family: 'Convergence'">
        <div class="container" style="background: transparent">
          <div class="row">
            <div class="col-lg-12 col-md-12">
              <div class="container mt-4">
                <div class="row justify-content-center">
                  <div
                    class="col-lg-6 col-md-6 col-sm-6 mb-4"
                    *ngFor="let item of paginated_teachers_info"
                    style="padding-bottom: 30px;"
                  >
                    <div class="card custom-card" style="height: 180px;padding-top: 10px;">
                    
                           <div class="container">
                            <div class="row">
                              <div class="col-4">   <img [src]="item.ImageLink" alt="image" style="width: 450px; height: 120px;"/> </div>
                               <div class="col-8"> 
                                 <div class="card-body text-center">
                        <h5 class="card-title" style="text-align: left;">{{ item.EmployeeName }}</h5>

                          <p  style="text-align: left;color: black;font-size: small;">
                          <strong>Department:</strong> {{ item.Department}} <br>
                       
                          <strong>Designation:</strong> {{item.Designation }} <br>
                            <a data-bs-toggle="modal" [attr.data-bs-target]="'#quote' + item.EmployeeId" style="color: white; background-color: rgb(54 120 111);border: 1px solid #ccc;padding: 5px;font-size: small;"  class="btn" > View profile </a>
                    
                        </p>
                      
      
                      

                       
                      
                         </div> 
                               </div>


                            </div>
                           </div>

                         
      
                       
                     
                               <!-- Modal -->
          <div class="modal fade" [id]="'quote' + item.EmployeeId" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-lg">
              <div class="modal-content">
                <div class="modal-header modal-quote-header">
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  
                </div>
                <div class="modal-body modal-quote-body">
                  <h5>ID: {{ item.EmployeeId }}</h5>
                  <h5>Name: {{ item.EmployeeName }}</h5>
                  <h5>Designation: {{ item.Designation }}</h5>
                  <h5>Department: {{ item.Department || '--' }}</h5>
                  <h5>Blood Group: {{ item.BloodGroup || '--' }}</h5>
                  <h5>Joining Date: {{ item.JoiningDate | date: 'dd-MM-yyyy' }}</h5>
                  <h5>Mobile: {{ item.MobileNo }}</h5>
                  <h5>Email: {{ item.EmailAddress || '--' }}</h5>
               
                </div>
              </div>
            </div>
          </div>
          <!-- Modal Ends -->
                    </div>
                  </div>
                </div>
      
                <!-- No Data Found Message -->
                <div *ngIf="paginated_teachers_info.length === 0">
                  <div class="page-title-content text-center mt-5 mb-5">
                    <h2>No Data Found</h2>
                  </div>
                </div>
              </div>
      
              <div class="pagination">
                <button
                  (click)="onPageChange(pageIndex - 1)"
                  [disabled]="pageIndex === 0"
                >
                  Previous
                </button>
      
                <button
                  *ngFor="let page of totalPages; let i = index"
                  (click)="onPageChange(i)"
                  [class.active]="pageIndex === i"
                >
                  {{ page }}
                </button>
      
                <button
                  (click)="onPageChange(pageIndex + 1)"
                  [disabled]="pageIndex + 1 >= totalPages.length"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      
     
</div>



